import axios from 'axios';

export const FETCH_ALL = async () => {
    const { data } = await axios.get('/api/additional-payment-types');

    return data;
};